import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 7.961A4.21 4.21 0 0 1 5.211 3.75H18.79A4.21 4.21 0 0 1 23 7.961v8.078a4.21 4.21 0 0 1-4.211 4.211H5.21A4.21 4.21 0 0 1 1 16.039zm5.627.26A1 1 0 1 0 5.373 9.78l4.045 3.258.036.027.009.006c.468.344 1.265.93 2.604.93 1.303 0 1.99-.479 2.324-.724l.045-.035 4.2-3.47a1 1 0 0 0-1.273-1.542l-4.178 3.451c-.098.072-.19.135-.334.192-.154.062-.4.128-.784.128-.664 0-1.02-.247-1.412-.535z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_mail_filled-WBAKAgr4.js.map
